const Loader = () => {
	return <span className='loading loading-spinner loading-md'></span>;
};

export default Loader;
